import { getData, sendData, sendForBlobData } from './apiService';
import NotificationManager from 'react-notifications/lib/NotificationManager';

export async function getCommercialInvoices(query) {
  try {
    const { limit, page, ...body } = query;
    let response = await sendData(
      `commercial-invoice/search?total=true&limit=${limit || 10}&page=${page || 1}`,
      body,
      'POST',
      false
    );
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function createCommercialInvoice(values) {
  try {
    return await sendData('commercial-invoice/create', values);
  } catch (e) {
    NotificationManager.error(e.response.data.message);
    return false;
  }
}

export async function deleteCommercialInvoice(_id) {
  try {
    let response = await sendData('commercial-invoice/delete', { id: _id });
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function deleteAllCommercialInvoices(data) {
  try {
    let response = await sendData('commercial-invoice', data, 'DELETE');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function updateCommercialInvoice(values) {
  try {
    return await sendData('commercial-invoice/update-commercial-invoice', values, 'PATCH');
  } catch (e) {
    NotificationManager.error(e.response.data.error);
    return false;
  }
}

export async function fetchInvoiceNumber() {
  try {
    let response = await getData('commercial-invoice/request-invoice-number');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function exportCommercialInvoices(data) {
  return await sendForBlobData('commercial-invoice/export-commercial-invoice', data, {
    responseType: 'blob',
  });
}

export async function exportCommercialInvoicesItems(data) {
  return await sendForBlobData('commercial-invoice/export-commercial-invoice-items', data, {
    responseType: 'blob',
  });
}

export async function getCommercialInvoiceByNumber(query) {
  try {
    let response = await getData(`commercial-invoice/get-commercial-invoice?${new URLSearchParams(query).toString()}`);
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function cancelInvoiceNumber(data) {
  try {
    let response = await sendData('commercial-invoice/cancel-commercial-invoice-number', data);
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}
